var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("span", { staticClass: "h4" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "apeironGwApp.programa.programaIntegrado.programasIntegrados"
                  )
                )
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-table", {
                staticClass: "area-responsive",
                staticStyle: { "max-height": "500px" },
                attrs: {
                  "sticky-header": "500px",
                  "head-variant": "dark",
                  items: _vm.programasIntegrados,
                  fields: _vm.programasIntegradosFields,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(clave)",
                    fn: function (data) {
                      return [
                        _c("span", {
                          domProps: { textContent: _vm._s(data.value) },
                        }),
                      ]
                    },
                  },
                  {
                    key: "cell(nombre)",
                    fn: function (data) {
                      return [
                        _c("span", {
                          domProps: { textContent: _vm._s(data.value) },
                        }),
                      ]
                    },
                  },
                  {
                    key: "cell(fechaInicio)",
                    fn: function (data) {
                      return [
                        _c("span", {
                          domProps: { textContent: _vm._s(data.value) },
                        }),
                      ]
                    },
                  },
                  {
                    key: "cell(fechaFin)",
                    fn: function (data) {
                      return [
                        _c("span", {
                          domProps: { textContent: _vm._s(data.value) },
                        }),
                      ]
                    },
                  },
                  {
                    key: "cell(acciones)",
                    fn: function (row) {
                      return [
                        _vm.esEscritura
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass: "mr-1",
                                attrs: {
                                  variant: "outline-primary",
                                  title: _vm.$t("entity.action.edit"),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.mostrarModalEditarPrograma(
                                      row.item
                                    )
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "mr-2",
                                  attrs: { icon: "pencil" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.esEscritura
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass: "mr-1",
                                attrs: {
                                  variant: "outline-danger",
                                  title: _vm.$t("entity.action.delete"),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.mostrarModalEliminarPrograma(
                                      row.item
                                    )
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "mr-2",
                                  attrs: { icon: "trash" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "text-right p-2" },
        [
          _c("b-col", [
            _c("span", {
              domProps: {
                textContent: _vm._s(
                  _vm.$t(
                    "apeironGwApp.programaIntegradoCon.listado.totalProgramas",
                    { total: _vm.registros }
                  )
                ),
              },
            }),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  attrs: { scrollable: "", "header-bg-variant": "primary" },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.programaIntegradoCon.listado.tituloEliminar"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "secondary" },
                                      on: {
                                        click: function ($event) {
                                          _vm.mostrarModalEliminar = false
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.programaIntegradoCon.listado.cerrar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.eliminarPrograma()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.programaIntegradoCon.listado.eliminar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.mostrarModalEliminar,
                    callback: function ($$v) {
                      _vm.mostrarModalEliminar = $$v
                    },
                    expression: "mostrarModalEliminar",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("p", {
                          staticClass: "modal-body text-center h3 mb-3",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "apeironGwApp.programaIntegradoCon.listado.confirmaEliminar"
                              )
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  staticStyle: { height: "200px" },
                  attrs: { "header-bg-variant": "primary", size: "lg" },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.programaIntegradoCon.listado.tituloEditar"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "outline-primary" },
                                      on: { click: _vm.quitarFechaFin },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.programaIntegradoCon.listado.borrarFechaFin"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "secondary" },
                                      on: {
                                        click: function ($event) {
                                          _vm.mostrarModalEditar = false
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.programaIntegradoCon.listado.cerrar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        disabled: _vm.formularioIsInvalid,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editarPrograma()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.programaIntegradoCon.listado.actualizar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.mostrarModalEditar,
                    callback: function ($$v) {
                      _vm.mostrarModalEditar = $$v
                    },
                    expression: "mostrarModalEditar",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("strong", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.programaIntegradoConSeleccionado.clave
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("span"),
                        _vm._v(" "),
                        _c("strong", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.programaIntegradoConSeleccionado.nombre
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "apeironGwApp.programaIntegradoCon.form.fechaInicio"
                                  ) + " *",
                                "label-for": "input-sm",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  disabled: !_vm.esEscritura,
                                  placeholder: _vm.$t(
                                    "apeironGwApp.programaIntegradoCon.form.fechaInicio"
                                  ),
                                  required: "",
                                  locale: "es",
                                  state:
                                    !_vm.$v.programaIntegradoConSeleccionado
                                      .fechaInicio.$invalid,
                                },
                                model: {
                                  value:
                                    _vm.programaIntegradoConSeleccionado
                                      .fechaInicio,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.programaIntegradoConSeleccionado,
                                      "fechaInicio",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "programaIntegradoConSeleccionado.fechaInicio",
                                },
                              }),
                              _vm._v(" "),
                              _vm.$v.programaIntegradoConSeleccionado
                                .fechaInicio.$invalid
                                ? _c("small", {
                                    staticClass: "text-danger",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.programaIntegradoCon.registro.indicarFechaInicial"
                                        )
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.programaIntegradoCon.form.fechaFin"
                                ),
                                "label-for": "input-sm",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                staticClass: "mb-2",
                                attrs: {
                                  disabled: !_vm.esEscritura,
                                  placeholder: _vm.$t(
                                    "apeironGwApp.programaIntegradoCon.form.fechaInicio"
                                  ),
                                  state:
                                    !_vm.$v.programaIntegradoConSeleccionado
                                      .fechaFin.$invalid,
                                  locale: "es",
                                },
                                model: {
                                  value:
                                    _vm.programaIntegradoConSeleccionado
                                      .fechaFin,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.programaIntegradoConSeleccionado,
                                      "fechaFin",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "programaIntegradoConSeleccionado.fechaFin",
                                },
                              }),
                              _vm._v(" "),
                              _vm.$v.programaIntegradoConSeleccionado.fechaFin
                                .$invalid
                                ? _c("small", {
                                    staticClass: "text-danger",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.programaIntegradoCon.registro.formularioInvalido"
                                        )
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }